<template>
  <FormMessages title="Registration form messages" :formData="formData" formType="attendee_registration" v-if="isWriteAvailable"/>
</template>

<script>
  import FormMessages from '@/components/shared/FormMessages'
  import mixins from '@/utils/mixins'

  export default {
    name: 'SettingsMessages',
    mixins: [mixins.isWriteAvailable],
    components: {FormMessages},
    data() {
      return {
        formData: {
          paymentDescription: '',
          registrationIsClosed: '',
          executePaymentSuccess: '',
          infoTextBelowRegistration : ''
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/messages.vue